import { GenerateId } from "../util";
import Engine from "./Engine";
import MonoBehavior from "./MonoBehavior";
import Transform from "./Transform";



export default class GameObject {

    id: string = GenerateId();
    engine: Engine;
    transform: Transform = new Transform(this);
    scripts: MonoBehavior[] = [];
    layer = 0;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    Equals(other: GameObject) {
        return this.id === other.id;
    }

    AddScript(type: typeof MonoBehavior, initialValues?: Record<string, any>): any {
        for (let i = 0; i < this.scripts.length; i++) {
            const script: MonoBehavior = this.scripts[i];
            if (script instanceof type) return;
        }

        const script = new type(this);

        this.scripts.push(script);

        script.Init();

        if (initialValues != undefined) {
            Object.assign(script, initialValues);
        }

        return script;

    }

    GetScript(type: typeof MonoBehavior): any {
        for (let i = 0; i < this.scripts.length; i++) {
            const script: MonoBehavior = this.scripts[i];
            
            if (script instanceof type) {
                return script;
            }
        }
    }

    RemoveScript(type: typeof MonoBehavior): void;
    RemoveScript(id: string): void;
    RemoveScript(idOrType: string|typeof MonoBehavior) {
        for (let i = 0; i < this.scripts.length; i++) {
            const script = this.scripts[i];

            if (typeof idOrType === "string") {
                if (script.id === idOrType) {
                    this.scripts.splice(i, 1);
                    return;
                }
            } else if (script instanceof idOrType) {
                this.scripts.splice(i, 1);
                return;
            }
        }
    }

}